<template>
  <div class="dsf_liveDetail" v-if="visible">
    <div class="live-top">
      <div class="live-top-inner" id="LiveHeader">
        <div class="live-top-inner-l">
          <button class="live-btn live-btn-playback" :class="state.value == 0 ? 'live-btn-appoint' : 'live-btn-playback'">
            {{ state.value == 1 ? "正在直播" : state.value == 0 ? "未开始" : "直播回放" }}
          </button>
          <span class="live-title ell" :title="liveInfo.title">{{ liveInfo.title || "暂无标题" }}</span>
        </div>
        <div class="live-top-inner-r">
          <div class="dingyue">
            <dsf-icon class="icon-yanjing1"></dsf-icon>
            <span>{{ views || 0 }}</span>
            <button v-if="state.value == 0" class="live-btn live-btn-handle-appoint" @click="liveAppointHandle">{{ !subscribe ? "订阅" : "取消订阅" }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="live-content">
      <div class="live-box" :style="{ width: conWidth, height: playerHeight }">
        <DsfNcLivePlayer v-if="getLivePlayer" playerWidth="100%" :isDesign="isDesign" :playerHeight="playerHeight" :channelId="liveInfo.channelValue" :liveInfo="liveData"></DsfNcLivePlayer>
        <dsfNcPlayer
          v-if="videoShow"
          ref="coursePlayer"
          width="100%"
          :altTabStop="altTabStop"
          :hint="false"
          :height="playerHeight"
          :playerParams="playerParams"
          :videoSource="videoSource"
          @playerPlayingTime="playerPlayingTime"
          @playerHasPlay="playerHasPlay"
          @playerHasPause="playerHasPause"
          @playHasEnd="playHasEnd"
        ></dsfNcPlayer>
        <div class="live-cover img-box" v-if="state.value == 0">
          <el-image :src="liveInfo.cover | imgFormat" fit="cover"></el-image>
          <div class="live-time-wrap">
            <div class="live-time-inner">
              <p class="p1">{{ liveInfo.stateValue == 0 ? "该直播间被停用" : "未开始" }}</p>
              <p class="p2">开播时间: {{ !!liveInfo.timeSdate ? liveInfo.timeSdate : "开播时间未定" }}</p>
            </div>
          </div>
        </div>
        <div class="live-cover img-box" v-if="getLiveState">
          <div v-if="liveInfo.stateValue == 0">
            <el-image :src="liveInfo.cover | imgFormat" fit="cover"></el-image>
            <div class="live-time-wrap">
              <div class="live-time-inner">
                <p class="p1">该直播间被停用</p>
                <p class="p2">直播时间: {{ liveInfo.timeSdate || "" }}</p>
              </div>
            </div>
          </div>
          <div class="pointer" v-else-if="liveInfo.typeValue == 2 && state.value !== 0 && liveInfo.stateValue != 0">
            <el-image :src="liveInfo.cover | imgFormat" fit="cover"></el-image>
            <div class="live-time-wrap">
              <div class="live-time-inner" @click="goLiveLink">
                <p class="p1">{{ state.value === 2 || state.value === 3 ? "回放中" : "直播中" }}</p>
                <p class="p2">{{ state.value === 2 || state.value === 3 ? "点击进入回放" : "点击进入直播" }}</p>
              </div>
            </div>
          </div>
          <div v-else>
            <el-image :src="liveInfo.cover | imgFormat" fit="cover"></el-image>
            <div class="live-time-wrap">
              <div class="live-time-inner">
                <p class="p1">直播结束</p>
                <p class="p2">直播时间: {{ liveInfo.timeSdate || "" }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-comment-warp">
        <div class="d-comment">
          <ul class="d-comment-handle">
            <li @click="handleClickTag" :class="{ isred: tag }">
              <dsf-icon class="pointer" :class="[tag ? 'icon-dianzan1' : 'icon-dianzan']"></dsf-icon>
              <span id="LiveDz" class="live-dz" :title="!tag ? '点赞' : '取消点赞'">{{ tagTotal }}</span>
            </li>
            <li @click="handleClickCollect" :class="{ isred: collect }">
              <dsf-icon class="pointer" :class="[collect ? 'icon-aixin_shixin' : 'icon-shoucang2 ']"></dsf-icon>
              <span id="LiveSc" class="live-sc" :title="!collect ? '收藏' : '取消收藏'">{{ collectTotal }}</span>
            </li>
            <li></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tabs">
      <div class="con-tab-head-wrap">
        <ul class="con-tabs" :style="{ width: conWidth }">
          <li :class="{ tabHasSel: activeName == index + 1 }" v-for="(item, index) in tabs" :key="index" @click="activeName = item.id">
            <span>{{ item.name }}</span>
          </li>
        </ul>
        <div class="tabs-content" :style="{ width: conWidth }">
          <div class="introduction" v-if="activeName == 1">
            <div class="introduction-left">
              <h3 class="course-tab-title">直播简介</h3>
              <div class="course-desc-warp">
                <div class="live-info live-info-bottom">
                  <div class="live-info-inner">
                    <div class="live-desc" id="LiveIntroduction">
                      <div class="live-info-sub-title">
                        <p class="live-s-title">{{ liveInfo.title }}</p>
                        <p class="live-s-time">开播时间：{{ formatterDate(liveInfo.timeSdate) }}</p>
                      </div>
                      <p class="live-text" v-html="liveInfo.content"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="introduction-right">
              <DsfNcLiveInformation></DsfNcLiveInformation>
            </div>
          </div>
          <div class="note-box">
            <dsf-nc-note-item v-if="activeName == 2" :relationId="liveId" :liveCover="liveCover" :relationTitle="liveInfo.title" :isLive="true" :btnWidth="'100px'" :fontColor="'#333'" />
          </div>
          <comment v-if="activeName == 3" class="note-box"></comment>
        </div>
      </div>
    </div>
    <div id="isvideo-box" v-if="mutedPlay">
      是否允许浏览器播放声音?
      <span class="ppt-control-volume-cancel isvideo" @click="handleMuted">播放声音</span>
      <span class="ppt-control-volume-close isvideoclose" @click="mutedPlay = false">忽略</span>
    </div>
  </div>
</template>

<script>
import { comment } from "../comment";
export default dsf.component({
  name: "DsfNcLiveDetail",
  ctrlCaption: "直播详情页",
  mixins: [$mixins.control],
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    conWidth: {
      type: String,
      default: "1200px",
    },
    playerHeight: {
      type: String,
      default: "650px",
    },
    ckplayerPause: {
      type: Boolean,
      default: false,
    },
    ckplayerShowProgress: {
      type: Boolean,
      default: true,
    },
    altTabStop: {
      type: Boolean,
      default: true,
    },
    //是否开启课程记录学时
    isCoursePlayerTime: {
      type: Boolean,
      default: true,
    },
    //非直播也记录学时
    notlivePlayerTime: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sourceUrl: "nc/live/info",
      liveId: "",
      liveInfo: {},
      liveData: {},
      state: {
        value: "5",
        text: "直播预设",
      },
      subscribeTotal: 0,
      views: 0,
      subscribe: false,
      tag: false,
      tagTotal: 0,
      collect: false,
      collectTotal: 0,
      curPlayItem: {},
      activeName: 1,
      tabs: [
        { name: "简介", id: 1 },
        { name: "笔记", id: 2 },
        // { name: "评价", id: 3 },
      ],
      mutedPlay: false,
      ckPlayer: null,
      videoSource: "",
      videoShow: false,
      playerParams: {
        playerID: "ncCourseCkplayer",
        container: "#dsfNcCkplayer",
        variable: "player",
        html5m3u8: true,
        loop: false,
        autoplay: false,
        sortPlay: true,
        next: "nextCourse",
        defaultPoster: "", //封面图片
        // seek: seekTime,
        playbackrate: 1,
        drag: "start",
        debug: false,
        hideautoplayBtn: true, //隐藏自动播放按钮
      },
      liveCover: "",
      playTimer: null,
      time: "0",
    };
  },
  computed: {
    //保利威视
    getLivePlayer() {
      let flag = false;
      if (this.state.value === 1 || this.state.value === 2 || this.state.value === 3) {
        //直播中或者直播结束 并且是发布状态
        if (this.liveInfo.typeValue === "1" && this.liveInfo.stateValue != 0) {
          //类型是保利直播
          flag = true;
        }
      }
      return flag;
    },

    //获取直播状态
    getLiveState() {
      let flag = false;
      //直播结束
      if (this.state.value === 2 || this.state.value === 3) {
        if (this.liveInfo.stateValue == 0) {
          //停用
          flag = true;
        }
        if (this.liveInfo.typeValue == 2) {
          // 链接
          flag = true;
        }
      } else if (this.state.value === 1) {
        if (this.liveInfo.typeValue == 2) {
          // 链接直播中 不管停用不停用
          flag = true;
        }
        //课件直播.视频直播停用
        if ((this.liveInfo.typeValue == 1 || this.liveInfo.typeValue == 3 || this.liveInfo.typeValue == 4) && this.liveInfo.stateValue == 0) {
          flag = true;
        }
      }
      return flag;
    },
  },
  components: {
    comment,
  },
  created() {
    this.liveId = this.queryString["id"] || "";
  },
  mounted() {
    this.getLiveInfo();
  },
  beforeDestroy() {
    this.clearPlayInterval();
  },
  methods: {
    //清除定时器
    clearPlayInterval() {
      if (this.playTimer) clearInterval(this.playTimer);
    },
    saveProgressTimer() {
      this.playTimer = setInterval(() => {
        this.saveRecord();
      }, 1000 * 10);
    },
    //播放器播放时间
    playerPlayingTime(e) {
      this.time = this.formatSeconds(Math.ceil(e));
    },
    formatSeconds(value) {
      let data = dsf.date.secondsToTime(value);
      let time = data.hours + ":" + data.minutes + ":" + data.seconds;
      return time;
    },
    playerHasPlay() {
      this.clearPlayInterval();
      //直播时
      if (this.state.value == 1) {
        if (this.isCoursePlayerTime) {
          this.saveProgressTimer();
        }
      } else {
        //非直播
        if (this.notlivePlayerTime) {
          this.saveProgressTimer();
        }
      }
    },
    playerHasPause() {
      this.clearPlayInterval();
    },
    playHasEnd() {
      this.clearPlayInterval();
      //直播时
      if (this.state.value == 1) {
        if (this.isCoursePlayerTime) {
          this.saveRecord();
        }
      } else {
        //非直播
        if (this.notlivePlayerTime) {
          this.saveRecord();
        }
      }
    },
    //保存进度
    saveRecord() {
      let params = {
        courseId: this.liveId,
        type: "live",
        coursewareId: this.liveInfo.coursewareValue,
        watchPoint: this.time,
        pulseTime: "10",
        pulseRate: "1",
      };
      let url = "nc/course/play/pulseSaveRecord";
      this.$http
        .post(url, params, $$webRoot.nc)
        .done(res => {})
        .error(function (err) {
          dsf.layer.pc.message(err.message || "进度保存失败", false);
        })
        .always(function () {});
    },
    //获取视频播放
    getVideoPlay() {
      let flag = false;
      if (this.state.value === 1 || this.state.value === 2 || this.state.value === 3) {
        //直播中和直播结束和直播回放
        //3课件 4视频
        if (this.liveInfo.typeValue === "3" || this.liveInfo.typeValue === "4") {
          //视频播放并且有video
          if (this.liveInfo.stateValue !== "0") {
            //启用状态
            flag = true;
          }
        }
        //链接直播 直播连接存在 并且未停用
        // if (this.liveInfo.typeValue === "2" && this.liveInfo.liveUrl && this.liveInfo.stateValue !== "0") {
        //   //弹出窗口
        // }
      }
      return flag;
    },
    getLiveInfo() {
      let params = {
        id: this.liveId,
      };
      this.$http
        .get(this.sourceUrl, params, $$webRoot.nc)
        .done(res => {
          if (res.success) {
            this.liveInfo = res.data.ncLiveInfo;
            this.liveCover = this.liveInfo.cover;
            this.liveData = res.data;
            this.state = res.data.state;
            this.subscribeTotal = res.data.subscribeTotal;
            this.views = res.data.ncLiveInfo.views || 0;
            this.tag = res.data.tag;
            this.tagTotal = res.data.tagTotal;
            this.subscribe = res.data.subscribe;
            this.collect = res.data.collect;
            this.collectTotal = res.data.collectTotal;
            // 2 链接直播 3课件 4视频
            // if ((this.state.value != 0 && this.liveInfo.typeValue == 3) || (this.state.value != 0 && this.liveInfo.typeValue == 4) || (this.state.value != 0 && this.liveInfo.typeValue == 2)) {
            if (this.state.value != 0 && this.liveInfo.typeValue != 1 && this.liveInfo.stateValue != 0) {
              this.setvideo();
            }
          }
        })
        .error(function (err) {
          dsf.layer.pc.message(err.message, false);
        })
        .always(function () {});
    },
    // 订阅
    liveAppointHandle() {
      let params = {
        ywid: this.liveId,
        ywlxValue: "live",
        ywlxText: "直播",
      };
      let loading = dsf.layer.pc.loading();
      let appointUrl = "dsfa/subscribe/saveOrCancel";
      this.$http
        .post(appointUrl, params, $$webRoot.nc)
        .done(res => {
          if (res.success) {
            this.subscribe = res.data.isDo;
            this.setNum(this.subscribe, "subscribeTotal");
          }
          dsf.layer.pc.message(res.message, true);
        })
        .error(function (err) {
          dsf.layer.pc.message(err.message, false);
        })
        .always(function () {
          dsf.layer.pc.closeLoading(loading);
        });
    },
    //点赞
    handleClickTag() {
      const dzUrl = "dsfa/tags/saveOrCancel";
      let params = {
        ywlxValue: "live",
        ywlxText: "直播",
        ywid: this.liveId,
      };
      const loading = dsf.layer.pc.loading();
      this.$http
        .post(dzUrl, params, $$webRoot.nc)
        .done(res => {
          if (res.success) {
            this.tag = res.data.isDo;
            this.setNum(this.tag, "tagTotal");
          }
          dsf.layer.pc.message(res.message, true);
        })
        .error(function (err) {
          dsf.layer.pc.message(err.message, false);
        })
        .always(function () {
          dsf.layer.pc.closeLoading(loading);
        });
    },
    // 收藏
    handleClickCollect() {
      const collectUrl = "dsfa/collect/saveOrCancel";
      let params = {
        ywlxValue: "live",
        ywlxText: "直播",
        ywid: this.liveId,
      };
      const loading = dsf.layer.pc.loading();
      this.$http
        .post(collectUrl, params, $$webRoot.nc)
        .done(res => {
          if (res.success) {
            this.collect = res.data.isDo;
            this.setNum(this.collect, "collectTotal");
          }
          dsf.layer.pc.message(res.message, true);
        })
        .error(function (err) {
          dsf.layer.pc.message(err.message, false);
        })
        .always(function () {
          dsf.layer.pc.closeLoading(loading);
        });
    },
    async setvideo() {
      if (this.liveInfo.typeValue != 2) {
        this.liveCover = "";
      }
      let vUrl = "",
        vType = "video/mp4";
      //是否切片   视频直播或者回放
      if (this.liveInfo.splitAddr && this.liveInfo.splitAddr.hd) {
        vUrl = this.videosHandle(this.liveInfo.splitAddr);
      } else if (this.liveInfo.video && this.liveInfo.video !== "[]") {
        vUrl = this.liveInfo.video ? JSON.parse(this.liveInfo.video)[0].relativePath : "";
        vType = this.liveInfo.video ? JSON.parse(this.liveInfo.video)[0].contentType : "video/mp4";
      }

      // 课件直播
      if (this.liveInfo.typeValue == 3) {
        this.videoSource = await this.getCourseVideoSrc();
      } else {
        // 未切片
        this.videoSource = dsf.url.getWebPath(vUrl);
        //切片
        if (this.liveInfo.splitAddr && this.liveInfo.splitAddr.hd) {
          this.videoSource = vUrl;
        }
      }
      console.log(this.videoSource);
      this.videoShow = false;
      this.videoShow = this.getVideoPlay();
      // 封面图片
      this.playerParams.defaultPoster = this.getUrl(this.liveInfo.cover);
      //直播时.设置player
      if (this.state.value == 1) {
        //切换不允许暂停
        this.altTabStop = false;
        this.playerParams.keyDown = {
          space: false, //是否启用空格键切换播放/暂停
          left: false, //是否启用左方向键快退
          right: false, //是否启用右方向键快进
          up: true, //是否支持上方向键增加音量
          down: true, //是否支持下方向键减少音量
        };
        this.playerParams.autoplay = true;
        this.playerParams.timeScheduleAdjust = 0;
        this.playerParams.islive = true;
        // this.playerParams.live = true;
        this.playerParams.seek = this.liveInfo.dwsj || 0;
        this.playerParams.click = false;
        this.playerParams.ckplayerPause = this.ckplayerPause;
        this.playerParams.loaded = "ckPlayerLoad";
        this.playerParams.loop = true;
        //是否显示进度条
        this.playerParams.hideProgress = this.ckplayerShowProgress;
        // 增加播放结束函数
        // this.playerParams.ended = "endedHandler";
        this.time = this.liveInfo.dwsj || 0;

        window.ckPlayerLoad = () => {
          this.ckPlayerLoad();
        };

        // window.endedHandler = function () {};
      } else {
        setTimeout(() => {
          window.playerLoaded();
          // if (this.$refs.coursePlayer) {
          //   this.ckPlayer = this.$refs.coursePlayer.ckPlayer;
          //   this.ckPlayer.addListener("screenshot", this.$refs.coursePlayer.playerScreenshot); //监听截图功能
          // }
        }, 200);
      }
    },
    getCourseVideoSrc() {
      return new Promise((resolve, reject) => {
        this.dsf.http
          .get(
            "nc/courseware/queryVideoUrlById",
            {
              coursewareId: this.liveInfo.coursewareValue,
            },
            $$webRoot.nc
          )
          .done(d => {
            if (d.success) {
              // videoSource
              if (d.data.fileUrl && d.data.fileUrl.length > 2) {
                let video = dsf.url.getWebPath(JSON.parse(d.data.fileUrl).sd.relative);
                !video && dsf.layer.message("视频不可用", false);
                resolve(video);
              }
            } else {
              this.dsf.layer.message(d.message || "查询异常", false);
            }
          })
          .error(response => {
            this.dsf.layer.message("服务器异常", false);
          });
      });
    },
    ckPlayerLoad() {
      this.mutedPlay = true;
      setTimeout(() => {
        window.playerLoaded();
        this.ckPlayer = this.$refs.coursePlayer.ckPlayer;
        this.ckPlayer.videoMute();
        this.ckPlayer.videoPlay();
        this.ckPlayer && this.ckPlayer.addListener("screenshot", this.$refs.coursePlayer.playerScreenshot); //监听截图功能
      }, 200);
    },
    handleMuted() {
      this.mutedPlay = false;
      this.ckPlayer.videoEscMute();
    },
    //获取视频源
    videosHandle(data) {
      let videoArr = [];
      if (data) {
        videoArr.push(
          [data.cd.url + "?t=1", "video/" + this.getFileExt(data.cd.url).substring(1), "清晰", 0],
          [data.sd.url + "?t=2", "video/" + this.getFileExt(data.sd.url).substring(1), "标清", 0],
          [data.hd.url + "?t=3", "video/" + this.getFileExt(data.hd.url).substring(1), "高清", 0]
        );
      }
      return videoArr;
    },
    //获取视频格式
    getFileExt(filePath) {
      if (filePath != "") {
        if (filePath.indexOf("?") > -1) {
          filePath = filePath.split("?")[0];
        }
        let pos = "." + filePath.replace(/.+\./, "");
        return pos.toLowerCase();
      }
      return "";
    },
    formatterDate(time, format) {
      return time ? dsf.date.format(time, !format ? "yyyy-mm-dd hh:ii" : format) : "";
    },
    setNum(val, tag) {
      if (val) {
        ++this[tag];
      } else {
        --this[tag];
        if (this[tag] < 0) {
          this[tag] = 0;
        }
      }
    },
    goLiveLink() {
      dsf.layer.openWindow(this.liveInfo.liveUrl);
    },
    getUrl(cover) {
      return cover ? dsf.url.getWebPath(JSON.parse(cover)[0].relativePath) : "";
    },
  },
});
</script>
<style lang="scss" scoped></style>
